export default __webpack_public_path__ + "static/media/fi_box_blue.7e533cd5.svg";